#import "./productPageProductFragment.gql"

query ProductByHandleQuery($handle: String!, $lang: LanguageCode!) @inContext(language: $lang) {
  productByHandle(handle: $handle) {
    ...productPageProductFragment
  }
}
